import styled from "styled-components";
import { PanelCard } from "@sonder/ui/source/styled/fragments/PanelCard";
import { borders } from "@sonder/ui/source/styled/theme";

export const PanelContent = styled.section`
  overflow-y: auto;
  grid-area: content;
  border-left: ${borders.standard};
  ${PanelCard} {
    &:first-child {
      margin-top: 1rem;
    }
  }
`;
